import { cn } from '@repo/utils';

interface PageSectionProps {
  title?: string;
  action?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
}

export function PageSection({ title, action, children, className }: PageSectionProps) {
  return (
    <section className={cn('flex flex-col gap-4', className)}>
      {(title || action) && (
        <div className="flex items-center justify-between gap-4">
          {title && (
            <h2 className="text-sm font-semibold text-text-secondary uppercase tracking-wide">
              {title}
            </h2>
          )}
          {action && <div>{action}</div>}
        </div>
      )}
      {children}
    </section>
  );
}
